export default class Map {
    init() {
        const ButtonsZoneMuni = document.querySelectorAll('.listMuni .single-link-zoneMuni');

        for (const buttonZoneMuni of ButtonsZoneMuni) {
            buttonZoneMuni.addEventListener('click', e => {
                this.switchZone(e);
            });
        }

        const BtnTer = document.getElementsByClassName('btnZoneTerritory');
        for (const btnZoneTer of BtnTer) {
            btnZoneTer.addEventListener('mouseover', e => {
                this.hoverBtnZone(e);
            });
            btnZoneTer.addEventListener('mouseout', e => {
                this.hoverOutBtnZone(e);
            });
            btnZoneTer.addEventListener('click', e => {
                this.closeListZone(e);
            });
        }

        const BtnZones = document.getElementsByClassName('mapZones');
        for (const btnZone of BtnZones) {
            btnZone.addEventListener('mouseover', e => {
                this.hoverBtnZone(e);
            });
            btnZone.addEventListener('mouseout', e => {
                this.hoverOutBtnZone(e);
            });
            btnZone.addEventListener('click', e => {
                this.openListZone(e);
            });
            btnZone.addEventListener('keydown', e => {
                this.handleKeydown(e);
            })
        }

        const Anchors = document.getElementsByClassName('single-anchor');
        for (const anchor of Anchors) {
            anchor.addEventListener('click', e => {
                this.scroll(e);
            });
        }

        const scrollTopBtn = document.getElementById('scrollToTop');
        if (scrollTopBtn) {
            scrollTopBtn.addEventListener('click', e => {
                this.scroll(e);
            });
        }

        const btnsZoneNav = document.querySelectorAll(".btn-zone-nav");

        if (btnsZoneNav) {
            for (const btnZoneNav of btnsZoneNav) {
                btnZoneNav.addEventListener('click', e => {
                    this.clickZoneNavBtn(e);
                });
            }
        }

        //dropdown simulate
        const btnsMobileZoneNav = document.querySelectorAll(".dropdown-btn");
        if(btnsMobileZoneNav){
            for (const btn of btnsMobileZoneNav) {
                btn.addEventListener('click', e => {
                    e.stopPropagation();
                    this.clickMobileZoneNav(e);
                });
            }
        }
    }
    handleKeydown(e) {
        if (e.key === 'Enter' || e.key === 'Space Bar') {
            var target = e.target;
            target.click();
        }
    }
    clickMobileZoneNav(e){
        e.stopPropagation();
        var target = e.target;
        var navZoneMobile = null;

        if(target.classList.contains("content") || target.classList.contains("svg") || target.classList.contains("path")){
            navZoneMobile = target.parentNode.parentNode;
            if(target.classList.contains("path")){
                navZoneMobile = dropdown.parentNode.parentNode;
            }
        }else{
            navZoneMobile = target.parentNode;
        }
        
        if(navZoneMobile && !navZoneMobile.classList.contains("disabled")){
            var content = navZoneMobile.querySelector(".dropdown-content");
            var btn = navZoneMobile.querySelector(".dropdown-btn");
            var svg = navZoneMobile.querySelector("svg");

            if(content.classList.contains("dropdown-content-show")){
                content.classList.remove("dropdown-content-show");
                btn.classList.remove("dropdown-btn-active")
            }else{
                content.classList.add("dropdown-content-show");
                btn.classList.add("dropdown-btn-active");

            }

            if(svg.classList.contains("svg-closed")){
                svg.classList.remove("svg-closed");
                svg.classList.add("svg-open");
            }else{
                svg.classList.remove("svg-open");
                svg.classList.add("svg-closed");
            }
        }
    }
    
    clickZoneNavBtn(e){
        var target = e.target;
        var type = target.classList[1];
        var parent = target.parentNode;
        var listingsNode = parent.nextElementSibling;
        var activeItem = null;
        var activeItem = "listSection_" + type;
        if(listingsNode){ //desktop
            var lists = [
                listingsNode.querySelectorAll(".listSection"),
            ];
        }else{ //mobile
            var singleZoneSect = parent.parentNode.parentNode.parentNode;
            var lists = [
                singleZoneSect.querySelectorAll(".listSection")
            ];
            var contentString = (target.innerHTML);
            var navZoneMobile = parent.parentNode.parentNode;
            var contentDropdown = navZoneMobile.querySelector(".dropdown-btn > .content");
            contentDropdown.innerHTML = contentString;
            //close dropdown
            parent.classList.remove("dropdown-content-show");
            parent.classList.remove("dropdown-btn-active");
            
        }
       

        for(var i = 0; i < lists.length; i++){
            var current = lists[i];
            for(var y = 0; y < current.length; y++){
                if(current[y].classList.contains(activeItem)){
                    current[y].classList.add("active");
                    current[y].parentNode.classList.add("active");
                }else{
                    current[y].classList.remove("active");
                    current[y].parentNode.classList.remove("active");
                }
            }
        }
        
        for (const btn of parent.children) {
            if(btn == target){
                btn.classList.add("active");
                this.addTrackingTabs(btn);
            }else{
                btn.classList.remove("active");
            }
        }
    }


    hoverBtnZone(e) {
        const et = e.currentTarget;
        const inactive = document.getElementsByClassName('inactive');

        const zoneA = document.getElementsByClassName('zoneA');
        const zoneB = document.getElementsByClassName('zoneB');
        const zoneC = document.getElementsByClassName('zoneC');
        const zoneD = document.getElementsByClassName('zoneD');
        const zoneA_letter = document.getElementsByClassName('zoneA_letter');
        const zoneB_letter = document.getElementsByClassName('zoneB_letter');
        const zoneC_letter = document.getElementsByClassName('zoneC_letter');
        const zoneD_letter = document.getElementsByClassName('zoneD_letter');

        if (et.classList.contains('btnZoneA')) {
            for (const b of zoneB) {
                b.classList.add('inactive');
            }

            for (const c of zoneC) {
                c.classList.add('inactive');
            }

            for (const d of zoneD) {
                d.classList.add('inactive');
            }

            for (const bl of zoneB_letter) {
                bl.classList.add('inactive');
            }

            for (const cl of zoneC_letter) {
                cl.classList.add('inactive');
            }

            for (const dl of zoneD_letter) {
                dl.classList.add('inactive');
            }
        }

        if (et.classList.contains('btnZoneB')) {
            for (const a of zoneA) {
                a.classList.add('inactive');
            }

            for (const c of zoneC) {
                c.classList.add('inactive');
            }

            for (const d of zoneD) {
                d.classList.add('inactive');
            }

            for (const al of zoneA_letter) {
                al.classList.add('inactive');
            }

            for (const cl of zoneC_letter) {
                cl.classList.add('inactive');
            }

            for (const dl of zoneD_letter) {
                dl.classList.add('inactive');
            }
        }

        if (et.classList.contains('btnZoneC')) {
            for (const a of zoneA) {
                a.classList.add('inactive');
            }

            for (const b of zoneB) {
                b.classList.add('inactive');
            }

            for (const d of zoneD) {
                d.classList.add('inactive');
            }

            for (const al of zoneA_letter) {
                al.classList.add('inactive');
            }

            for (const bl of zoneB_letter) {
                bl.classList.add('inactive');
            }

            for (const dl of zoneD_letter) {
                dl.classList.add('inactive');
            }
        }

        if (et.classList.contains('btnZoneD')) {
            for (const a of zoneA) {
                a.classList.add('inactive');
            }

            for (const b of zoneB) {
                b.classList.add('inactive');
            }

            for (const c of zoneC) {
                c.classList.add('inactive');
            }

            for (const al of zoneA_letter) {
                al.classList.add('inactive');
            }

            for (const bl of zoneB_letter) {
                bl.classList.add('inactive');
            }

            for (const cl of zoneC_letter) {
                cl.classList.add('inactive');
            }
        }

        if (et.classList.contains('btnZoneTerritory')) {
            for (const a of zoneA) {
                a.classList.add('inactive');
            }

            for (const b of zoneB) {
                b.classList.add('inactive');
            }

            for (const c of zoneC) {
                c.classList.add('inactive');
            }

            for (const d of zoneD) {
                d.classList.add('inactive');
            }

            for (const al of zoneA_letter) {
                al.classList.add('inactive');
            }

            for (const bl of zoneB_letter) {
                bl.classList.add('inactive');
            }

            for (const cl of zoneC_letter) {
                cl.classList.add('inactive');
            }

            for (const dl of zoneD_letter) {
                dl.classList.add('inactive');
            }
        }
    }

    hoverOutBtnZone(e) {
        const et = e.currentTarget;
        const inactive = document.getElementsByClassName('inactive');

        const zoneA = document.getElementsByClassName('zoneA');
        const zoneB = document.getElementsByClassName('zoneB');
        const zoneC = document.getElementsByClassName('zoneC');
        const zoneD = document.getElementsByClassName('zoneD');
        const zoneA_letter = document.getElementsByClassName('zoneA_letter');
        const zoneB_letter = document.getElementsByClassName('zoneB_letter');
        const zoneC_letter = document.getElementsByClassName('zoneC_letter');
        const zoneD_letter = document.getElementsByClassName('zoneD_letter');

        for (const a of zoneA) {
            a.classList.remove('inactive');
        }

        for (const b of zoneB) {
            b.classList.remove('inactive');
        }

        for (const c of zoneC) {
            c.classList.remove('inactive');
        }

        for (const d of zoneD) {
            d.classList.remove('inactive');
        }

        for (const al of zoneA_letter) {
            al.classList.remove('inactive');
        }

        for (const bl of zoneB_letter) {
            bl.classList.remove('inactive');
        }

        for (const cl of zoneC_letter) {
            cl.classList.remove('inactive');
        }

        for (const dl of zoneD_letter) {
            dl.classList.remove('inactive');
        }
    }

    closeListZone(e) {
        const et = e.currentTarget;

        const allContent = document.querySelectorAll('.single-zone_info');

        for (const content of allContent) {
            if (content.getAttribute('data-zone-map') === et.getAttribute('data-zone-map')) {
                content.style.display = 'block';
            } else {
                content.style.display = 'none';
            }
        }
        this.addTracking(et);
    }

    openListZone(e) {
        const et = e.currentTarget;

        const allContent = document.querySelectorAll('.single-zone_info');

        for (const content of allContent) {
            if (content.getAttribute('data-zone-map') === et.getAttribute('data-zone-map')) {
                content.style.display = 'block';
            } else {
                content.style.display = 'none';
            }
        }
        this.addTracking(et);
        this.scrollToZone();
    }

    scrollToZone() {
        var target = document.getElementById('zonesMapInfos').getBoundingClientRect().top;

        const btnMapZones = document.getElementsByClassName('btnMapZones');
        const btnZonesScroll = document.getElementsByClassName('btnZones');

        for (const btnMapZone of btnMapZones) {
            btnMapZone.classList.add('disableCursor');
        }

        for (const btnZoneScroll of btnZonesScroll) {
            btnZoneScroll.classList.add('disableCursor');
        }

        this.animateScroll(target, () => {
            for (const btnMapZone of btnMapZones) {
                btnMapZone.classList.remove('disableCursor');
            }

            for (const btnZoneScroll of btnZonesScroll) {
                btnZoneScroll.classList.remove('disableCursor');
            }
        });
    }

    scroll(e) {
        

        e.preventDefault();
        var id = e.currentTarget.getAttribute('href').replace('#', '');
        var target = document.getElementById(id).getBoundingClientRect().top;
        this.animateScroll(target);
    }

    animateScroll(targetHeight, callback) {

        targetHeight = document.body.scrollHeight - window.innerHeight > targetHeight + scrollY
            ? targetHeight : document.body.scrollHeight - window.innerHeight;
        var initialPosition = window.scrollY;
        var SCROLL_DURATION = 30;
        var step_x = Math.PI / SCROLL_DURATION;
        var step_count = 0;
        function step() {
            if (step_count < SCROLL_DURATION) {
                requestAnimationFrame(step);
                step_count++;
                window.scrollTo(0, initialPosition + targetHeight * 0.25 * Math.pow(1 - Math.cos(step_x * step_count), 2));
            } else if (step_count == SCROLL_DURATION) {
                if (typeof callback == 'function') {
                    callback();
                }
            }
        }
        requestAnimationFrame(step);
    }

    switchZone(e) {
        const et = e.target;
        const actives = document.querySelectorAll('.single-link-zoneMuni.active');
        const searchMuni = document.querySelector('.searchMuni');
        const btnsSingleMuni = document.querySelectorAll('.btnSingleMuni');

        if (! searchMuni.classList.contains('openModal')) {
            searchMuni.classList.add('openModal');
        }

        for (const active of actives) {
            active.classList.remove('active');
        }

        et.classList.add('active');

        const allContent = document.querySelectorAll('.single-zone');

        for (const content of allContent) {
            if (content.getAttribute('data-zone') === et.getAttribute('data-zone')) {
                content.style.display = 'block';
            } else {
                content.style.display = 'none';
            }
        }

        for (const btnSingleMuni of btnsSingleMuni) {
            if (et.getAttribute('data-id')) {
                const hrefNoParam = btnSingleMuni.href.substr(0, btnSingleMuni.href.indexOf('?')) || btnSingleMuni.href;
                btnSingleMuni.href = `${hrefNoParam}?muni=${et.getAttribute('data-id')}`;
            }
        }
    }

    searchThroughList(e) {
        var search = e.currentTarget.value.toLowerCase();
        document.querySelectorAll('.containerMuni li').forEach(row=> {
            var text = row.innerText.toLowerCase();
            if (text.match(search)) {
                row.style.display = 'block';
            } else {
                row.style.display = 'none';
            }
        });
    }

    addTracking(e){
        var type = "";
        var zone = e.getAttribute('data-zone-map');
        if(e.tagName == "path"){
            type = "carte";
        }else{
            type = "button"
        }

        if(zone == "E"){
            zone = "Territoire"
        }
        window.dataLayer = window.dataLayer || [];
        
        window.dataLayer.push({
            'event': 'interaction_carte',
            'interaction_type': type, 
            'click_text': "N/A",
            'zone': zone 
        });
    }
    addTrackingTabs(e){
        var type = "onglet"
        var zone = e.getAttribute('data-zone-map');
        var text = e.getAttribute('data-content');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'interaction_carte',
            'interaction_type': type, 
            'click_text': text, 
            'zone': zone 
        });
    }
}